export const getCommerceSearchInitialState = () => ({
    error: null,
    isLoading: false,
    requestId: '',
    responseId: '',
    products: [],
    facets: [],
    queryExecuted: '',
});
